import { render } from "./About.vue?vue&type=template&id=98982080&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=98982080&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sbausch.SVA\\OneDrive - SVA System Vertrieb Alexander GmbH\\Desktop\\taschenrechner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98982080"]])

export default __exports__